/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import Input from 'components/shared/FormElements/Input/Input';
import { useFormContext } from 'react-hook-form';

const Name = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { showGenericError } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)
  const { register } = useFormContext(); // Get useForm methods

  // Labels used on inputs and for validation
  const fNameLabel = 'First name';
  const lNameLabel = 'Last name';

  return (
    <div>
      {/* Show generic error message */}
      {showGenericError}

      <Input
        className="ds-col-1 ds-col-lg-3-4"
        name="Firstname"
        label={fNameLabel}
        autocomplete="given-name"
        fieldValidation={register({
          required: `Please enter your First name to proceed`,
        })}
      />
      <Input
        className="ds-col-1 ds-col-lg-3-4"
        name="LastName"
        label={lNameLabel}
        autocomplete="family-name"
        fieldValidation={register({
          required: `Please enter your Last  name to proceed`,
        })}
      />
    </div>
  );
};

export default Name;
